var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.Value != '0001-01-01T00:00:00')?_c('div',[_vm._v(" "+_vm._s(new Date(_vm.Value).toLocaleString())+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }